module.exports = __webpack_public_path__ + "static/media/championsCup.f77e6dfa.svg";